import { ESolutionCode, ICommon, UserInfo } from "@/types";


export const common: ICommon = {
  token: '',
  tenantCode: '',
  orgId: '',
  storeId: '',
  language: 'en-US',
  bizType: '',
  agentRoleCode: '',
  solution_code: ESolutionCode.DEV_CENTER,
  source: '',
  timezone: '',
  currency: '',
  roles: '',
};

export const userInfo:UserInfo = {
  email: '',
  uid: '',
  phone: '',
};

/** 宿主常把 uid 传成 number，trim 前必须先转成字符串 */
const asTrimmedString = (value: unknown): string => {
  if (value == null) return '';
  return String(value).trim();
};

export const setUserInfo = (email: unknown, uid: unknown, phone: unknown) => {
  userInfo.email = asTrimmedString(email);
  userInfo.uid = asTrimmedString(uid);
  userInfo.phone = asTrimmedString(phone);
};
export const setCommon = <K extends keyof ICommon>(key: K, value: ICommon[K]) => {
  common[key] = value;
};

/** Mind「联网搜索」：选中 auto，取消 never。默认选中。 */
export type WebFetchMode = 'auto' | 'never';

let webFetchMode: WebFetchMode = 'auto';

export const setWebFetchEnabled = (enabled: boolean): void => {
  webFetchMode = enabled ? 'auto' : 'never';
};

export const getWebFetchMode = (): WebFetchMode => webFetchMode;

/** 身份标识：uid > phone > email，都空则返回空串 */
export const getIdentityUid = (): string =>
  asTrimmedString(userInfo?.uid) || asTrimmedString(userInfo?.phone) || asTrimmedString(userInfo?.email) || '';